module.exports = __webpack_public_path__ + "static/media/arandano_big.65d3b84d.png";